import * as a from "react";
import u from "../../classnames/index.mjs";
var p = function(e) {
  var c = e.className, t = e.customizeIcon, r = e.customizeIconProps, s = e.onMouseDown, i = e.onClick, l = e.children, o;
  return typeof t == "function" ? o = t(r) : o = t, /* @__PURE__ */ a.createElement("span", {
    className: c,
    onMouseDown: function(n) {
      n.preventDefault(), s && s(n);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: i,
    "aria-hidden": !0
  }, o !== void 0 ? o : /* @__PURE__ */ a.createElement("span", {
    className: u(c.split(/\s+/).map(function(n) {
      return "".concat(n, "-icon");
    }))
  }, l));
};
export {
  p as default
};
//# sourceMappingURL=TransBtn.mjs.map
